import { Bugfender } from '@bugfender/sdk';

import { useDrawerOpenTracker } from '@/context';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { cancelSignOut, signOut } from '@/redux/auth/actions';

import { ConfirmDrawer } from './ConfirmDrawer';

export function SignOutDrawer() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();

  // Only mounted while isSignOutConfirming is true, so it's always "open"
  // for as long as it's mounted.
  useDrawerOpenTracker(true);

  const doSignOut = () => {
    dispatch(signOut());
    Bugfender.removeDeviceKey('operationId');
  };

  const onCancel = () => dispatch(cancelSignOut());

  return (
    <ConfirmDrawer
      title={t('signOutDrawer.title')}
      description={t('signOutDrawer.description')}
      secondaryAction={doSignOut}
      secondaryText={t('signOutDrawer.button.logout')}
      primaryAction={onCancel}
      primaryText={t('signOutDrawer.button.cancel')}
      onClose={onCancel}
    />
  );
}
